/**
 * UI component for Admin Feedback screen. It:
 * - renders screen "Admin Feedback"
 * - has different views for mobile and desktop
 * - renders list of feedback from users in a proper table
 */

import { useMediaQuery } from "react-responsive";
import { Timestamp } from "firebase/firestore";

import {
  BackScreenDiv,
  Button,
  ContentDiv,
  Div,
  FeedbackTableHeaderDiv,
  FeedbackTableRowDiv,
  H1,
  HeaderDiv,
  ScreenDiv,
  TableColumnDiv,
  UserColumnRowDiv,
  UserTableBodyDiv,
  UserTableDiv,
  UserTableRowDiv,
} from "../../../styles/styles";

const formatDateOnly = (ts) => {
  try {
    let dateObj = null;
    if (ts instanceof Timestamp) dateObj = ts.toDate();
    else if (ts?.toDate) dateObj = ts.toDate();
    else if (ts instanceof Date) dateObj = ts;
    else if (typeof ts === "string") {
      const d = new Date(ts);
      if (!isNaN(d.getTime())) dateObj = d;
    }
    if (dateObj) return dateObj.toLocaleDateString();
  } catch (e) {
    console.error("Error formatting feedback date:", e);
  }
  return "—";
};

const getPlanLabel = (row) => {
  if (row?.accessTier) return row.accessTier;
  if (row?.plan) return row.plan;
  return "—";
};

export default function AdminFeedback({
  rows,
  loading,
  error,
  done,
  onRefresh,
  onLoadMore,
}) {
  const isDesktop = useMediaQuery({ minWidth: "800px" });

  return (
    <>
      <BackScreenDiv grayImage />

      <ScreenDiv column mobileJustifySpace>
        <HeaderDiv />

        <ContentDiv
          gap={!isDesktop && "5px"}
          paddingBack={isDesktop}
          borderRadius="30px"
          alignStart
          justifyStart
          height="auto"
          heightDesktop="auto"
        >
          <Div row>
            {isDesktop && <H1>Feedback</H1>}
            <Button
              onClick={onRefresh}
              disabled={loading}
              width="auto"
              greenButton
            >
              {loading ? "Loading…" : "Update"}
            </Button>
          </Div>

          <Div>
            {error && (
              <div role="alert" style={{ color: "#c62828", marginBottom: 8 }}>
                {error}
              </div>
            )}

            <UserTableDiv>
              <FeedbackTableHeaderDiv>
                <UserColumnRowDiv style={{ padding: "10px 4px", textAlign: "center" }}>
                  #
                </UserColumnRowDiv>
                <UserColumnRowDiv>Email</UserColumnRowDiv>
                <UserColumnRowDiv>Created</UserColumnRowDiv>
                <UserColumnRowDiv>Plan</UserColumnRowDiv>
                <UserColumnRowDiv>App version</UserColumnRowDiv>
                <UserColumnRowDiv>Message</UserColumnRowDiv>
              </FeedbackTableHeaderDiv>

              <UserTableBodyDiv>
                {rows.map((r, index) => (
                  <FeedbackTableRowDiv key={r.id}>
                    <TableColumnDiv
                      style={{
                        padding: "0 4px",
                        textAlign: "center",
                        wordBreak: "normal",
                      }}
                    >
                      #{index + 1}
                    </TableColumnDiv>
                    <TableColumnDiv
                      title={r.email || undefined}
                      style={{
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        wordBreak: "normal",
                      }}
                    >
                      {r.email || "—"}
                    </TableColumnDiv>
                    <TableColumnDiv>{formatDateOnly(r.createdAt)}</TableColumnDiv>
                    <TableColumnDiv>{getPlanLabel(r)}</TableColumnDiv>
                    <TableColumnDiv>{r.appVersion || "—"}</TableColumnDiv>
                    <TableColumnDiv fontSize="14px" textAlign="left">
                      {r.message || "—"}
                    </TableColumnDiv>
                  </FeedbackTableRowDiv>
                ))}
                {rows.length === 0 && (
                  <UserTableRowDiv>
                    <UserColumnRowDiv>No data yet</UserColumnRowDiv>
                  </UserTableRowDiv>
                )}
              </UserTableBodyDiv>
            </UserTableDiv>

            {!done && (
              <button
                onClick={onLoadMore}
                disabled={loading}
                style={{ marginTop: 12, padding: "8px 12px" }}
              >
                {loading ? "Loading…" : "Load more"}
              </button>
            )}
          </Div>
        </ContentDiv>
      </ScreenDiv>
    </>
  );
}
